import React from 'react';
import PromotionHeader  from "./PromotionHeader";
import Create  from "./PromotionBody/create";
import Preview  from "./PromotionBody/preview";
import Edit  from "./PromotionBody/edit";
import List  from "./PromotionBody/list";
import Detail  from "./PromotionBody/detail";
import DetailView  from "./ViewDetail";
import "./promotion.css";

const PromotionComponent = (props) => {
    
    let promotionBody = null;
    let promotionPage = null;
    if(window.location.href.includes('promotion_create') == true){
      promotionBody = <Create />
      promotionPage = 'Create';
    }else if(window.location.href.includes('promotion_preview') == true){
      promotionBody = <Preview />
      promotionPage = 'Preview';
    }else if(window.location.href.includes('promotion_edit') == true){
      promotionBody = <Edit />
      promotionPage = 'Preview';
    }else if(window.location.href.includes('promotion_list') == true){
      promotionBody = <List />
      promotionPage = 'List';
    }else if(window.location.href.includes('promotion_detail') == true){
      promotionBody = <DetailView promotionId={props.promotionId}/>
      promotionPage = 'DetailView';
    }else if(window.location.href.includes('promotion') == true){
      promotionBody = <Detail promotionId={props.promotionId}/>
      promotionPage = 'Detail';
    }
  return (
  
    <div className="container">
       {/*  {(promotionPage != 'DetailView') ?
          <PromotionHeader  promotionPage={promotionPage} />  
          : null
        } 
         */}
        { (window.location.href.includes('promotion_detail') == true) ? 
            <div class="clr25"></div>
          : null
        } 
        {promotionBody}
    </div>
  );
} 
export default PromotionComponent;


